import {Injectable} from '@angular/core';
import {KeycloakService} from 'keycloak-angular';
import {environment} from '../../../environments/environment';
import {AuthServicesService, OauthService} from 'mclane-webauth-lib';

@Injectable({
  providedIn: 'root'
})
export class KeycloakServices {
  _keycloak: KeycloakService;
  authenticated: boolean;
  token: any;
  uRoles: string[];

  constructor(private keycloakService: KeycloakService, public _authService: AuthServicesService, public _oauthService: OauthService) {
    this._keycloak = keycloakService;
}

  initializer(): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        await this._keycloak.init({
          config: environment.keycloak,
          initOptions: {
            onLoad: 'login-required',
            checkLoginIframe: false
          },
        });
        resolve(true);
      } catch (error) {
        reject(error);
      }
    });
  }

  clearToken() {
    return this._oauthService.keycloakService.clearToken();
  }


}



